<template>
  <!--
      	作者：luoyiming
      	时间：2019-06-04
      	描述：插件中心-优惠券-发送优惠券
      -->
  <div class="user">
    <div class="product-content">
      <el-form ref="form" size="small" :model="form" label-width="150px">

        <div class="common-form">分享设置</div>
        <el-form-item label="分享背景图">
          <div v-if="form.share.imageUrl" class="default-image-box" @click="openShareImgUpload('share')">
            <div class="image-box">
              <img :src="form.share.imageUrl" alt="product_plus_image">
              <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg('share')" >
                <i class="el-icon-close"></i>
              </a>
            </div>
          </div>
          <div v-else>
            <div class="img-select" @click="openShareImgUpload('share')"><i class="el-icon-plus"></i></div>
          </div>
          <div class="lh18 mt10 gray9">
            <p>推荐尺寸：显示图片长宽为 500×400</p>
          </div>
        </el-form-item>
        <el-form-item label="兑换页图片">
          <div v-if="form.exchange_bg" class="default-image-box" @click="openShareImgUpload('exchange_bg')">
            <div class="image-box">
              <img :src="form.exchange_bg" alt="product_plus_image">
              <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg('exchange_bg')" >
                <i class="el-icon-close"></i>
              </a>
            </div>
          </div>
          <div v-else>
            <div class="img-select" @click="openShareImgUpload('exchange_bg')"><i class="el-icon-plus"></i></div>
          </div>
          <div class="lh18 mt10 gray9">
            <p>推荐尺寸：建议尺寸750宽</p>
          </div>
        </el-form-item>

<!-- 
      <div class="common-form">卡包二维码设置</div>
      <el-form-item label="卡包二维码有效时间">
        <el-input placeholder="请输入几分钟" type="number" v-model="form.minutes" class="max-w460">
        </el-input>
      </el-form-item> -->

<!-- 
        <div class="common-form">卡包充值设置</div>
      <el-form-item label="卡余额充值">
        <el-radio v-model="form.is_open" :label="0">关闭</el-radio>
        <el-radio v-model="form.is_open" :label="1">开启</el-radio>
      </el-form-item>
      <el-form-item label="充值比例">
        <el-input placeholder="请输入充值比例" type="number" v-model="form.recharge_ratio" class="max-w460">
          <template slot="prepend">1元可充值</template>
          <template slot="append">{{ getAppinfo('balance_text') }}</template>
        </el-input>
      </el-form-item>
      <el-form-item label="自定义文字" :rules="[{required: true,message: ' '}]">
        <el-input type="textarea" rows="5" v-model="form.remark" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="开启充值有礼">
        <el-radio v-model="form.is_recharge_give" :label="0">关闭</el-radio>
        <el-radio v-model="form.is_recharge_give" :label="1">开启</el-radio>
      </el-form-item>
      <el-form-item label="充值赠送">
        <el-input placeholder="请输入充值金额" type="number" v-model="form.recharge_money" class="max-w460">
          <template slot="prepend">充值</template>
          <template slot="append">{{ 卡余额}}</template>
        </el-input>
        <el-input placeholder="请输入赠送金额" type="number" v-model="form.give_money" class="max-w460">
          <template slot="prepend">赠送</template>
          <template slot="append">{{ 卡余额}}</template>
        </el-input>
      </el-form-item> -->


        <!--提交-->
        <div class="common-button-wrapper">
          <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
        </div>
      </el-form>
    </div>
    <!--商品图片组件-->
    <Upload v-if="isShareImgUpload" :config="{ total: 9 }" :isupload="isShareImgUpload" @returnImgs="returnProductImgsFunc">上传图片</Upload>
  </div>
</template>

<script>
import CouponApi from '@/api/coupon.js';
import Upload from "@/components/file/Upload";
export default {
  components: {
    Upload,
  },
  data() {
    return {
      /*是否加载完成*/
      loading: false,
      /*表单数据对象*/
      form: {
        share: {
          imageUrl: ''
        },
        exchange_bg:'',
      },
      type:'share',
      // 是否打开分享图片上传窗口
      isShareImgUpload: false,
    };
  },
  created() {
    this.getData()
  },
  methods: {

    // 获取设置配置
    getData() {
      let self = this
      self.loading = true
      let params = self.form
      CouponApi.getCouponSet(params)
        .then(data => {
          self.loading = false
          self.form = data.data
        }).catch(error => {
        self.loading = false
      })
    },

    /*提交*/
    onSubmit() {
      let self = this
      CouponApi.setCouponSet(self.form, true)
        .then(data => {
          self.loading = false
          self.$message({
            message: '发送成功',
            type: 'success'
          });
        }).catch(error => {
          self.loading = false
        })
    },
    // 打开分享图片
    openShareImgUpload(type) {
      this.type = type;
      this.isShareImgUpload = true;
    },
    /*删除商品图片*/
    deleteImg(type) {
      if(type=='share'){
        this.form.share.imageUrl = ''
      }else{
        this.form.exchange_bg = ''
      }
      
    },
    /*上传商品图片*/
    returnProductImgsFunc(e) {
      if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });
        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false
        }
        console.log(e)
        if(this.type=='share'){
          this.form.share.imageUrl = e[0].file_path
        }else{
          this.form.exchange_bg = e[0].file_path
        }
        
      }
      this.isShareImgUpload = false
    },
  }
};
</script>

<style lang="scss" scoped>

.img-select {
  position: relative;
  width: 110px;
  height: 110px;
  margin-right: 10px;
  i {
    display: flex;
    line-height: 110px;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    border: 1px dashed #dddddd;
    font-size: 30px;
    color: #409eff;
  }
}
.image-box {
  width: 110px;
  height: 110px;
  overflow: hidden;
  img {
    width: 110px;
    //height: 110px;
  }
}
.image-box:hover .delete-btn {
  display: block;
}
.default-image-box {
  position: relative;
  width: 110px;
  height: 110px;
}
.delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

</style>



// WEBPACK FOOTER //
// src/views/plus/coupon/coupon/CouponSet.vue